import { SubHeader } from "@src/components/atoms/sub-header/sub-header";
import { SubTitle } from "@src/components/atoms/sub-title/sub-title";
import { ContainerPanel } from "@src/components/organisms/container-panel/container-panel";
import { MainContainer } from "@src/components/templates/layouts/main-container/main-container";
import { RoundBorderComponentContainer } from "@src/components/templates/layouts/round-border-component-container/round-border-component-container";
import React from "react";
import { MachineOverviewContainer } from "../../organisms/machine-overview-container/machine-overview-container";
import { MachineOverviewContainerDrBoy } from "../../organisms/machine-overview-container-dr-boy/machine-overview-container-dr-boy";
import { MachineOverviewContainerChenHsong } from "../../organisms/machine-overview-container-chen-hsong/machine-overview-container-chen-hsong";
import { StaticMachineOverviewContainerForTt } from "@src/components/organisms/static-machine-overview-container-for-tt/static-machine-overview-container-for-tt";
import { staticTTMachinesData } from "@src/components/pages/factory-dashboard/static-tt-data";
import styles from "./factory-dashboard-page.module.scss";
import { ContainerPane } from "@src/components/organisms/container-pane/container-pane";
import { useI18N } from "@src/language/language-context";
import { useFactoryDashboard } from "./use-factory-dashboard";
import { staticIMMACMachinesData } from "./static-immac-data";
import { useFeatureFlag } from "@src/hooks/use-feature-flag";

const cssClassName = "factory-dashboard-page";

export const FactoryDashboardPage = () => {
  const i18n = useI18N();
  const machines = useFactoryDashboard();
  const factoryDashboardFlavor = useFeatureFlag(
    "factory-dashboard-flavor",
    "default",
  );
  const machineOverviewCards = (() => {
    switch (factoryDashboardFlavor) {
      case "tt":
        return staticTTMachinesData.map((machine) => (
          <StaticMachineOverviewContainerForTt
            key={machine.machineName}
            machine={machine}
            gridArea="quarter"
          />
        ));

      case "drboy":
        return machines.map((machine) => (
          <MachineOverviewContainerDrBoy
            key={machine.sourceId}
            machine={machine}
            gridArea="quarter"
          />
        ));

      case "chenhsong":
        return machines.map((machine) => (
          <MachineOverviewContainerChenHsong
            key={machine.sourceId}
            machine={machine}
            gridArea="quarter"
          />
        ));

      case "immac":
        return staticIMMACMachinesData.map((machine) => (
          <StaticMachineOverviewContainerForTt
            key={machine.machineName}
            machine={machine}
            gridArea="quarter"
          />
        ));

      default:
        return machines.map((machine) => (
          <MachineOverviewContainer
            key={machine.sourceId}
            machine={machine}
            gridArea="quarter"
          />
        ));
    }
  })();

  return (
    <MainContainer>
      <RoundBorderComponentContainer>
        <ContainerPanel>
          <SubHeader>
            <SubTitle text={i18n("modules.factoryDashboardPage.title")} />
          </SubHeader>
          <ContainerPane>
            <div className={styles[cssClassName]}>{machineOverviewCards}</div>
          </ContainerPane>
        </ContainerPanel>
      </RoundBorderComponentContainer>
    </MainContainer>
  );
};
